window['villaMap'] = function() {
    const $map = $('#map');
    const coordinates = $map.data('coordinates');
    const position = {
        lat: parseFloat(coordinates.latitude),
        lng: parseFloat(coordinates.longitude),
    };

    const map = new google.maps.Map($map[0], {
        zoom: 15,
        center: position,
        // @ts-ignore
        mapId: "b61a985732f65dd8",
    });

    new google.maps.Marker({
        position: position,
        map,
        animation: google.maps.Animation.DROP,
    });
}
